import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import RetakeExamButton from './RetakeExamButton';
import { useFullTrack } from '../../tracks';
import { useMostRecentExamAttempt, useExamAttemptExpiry } from '../../exams';
import { jsx as _jsx } from "react/jsx-runtime";
/* This scenario can occur when a user completes the exam _without_ first completing
 * the graded practical exercises. Then after the attempt expires after a year, they
 * complete the practical exercises, but are unable to receive a certificate as
 * it's been more than a year since the last exam attempt.
 */
const ExamAttemptExpiredScreen = ({
  trackId,
  language
}) => {
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId), language);
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId, language);
  const {
    attemptExpiresOn,
    attemptExpiryLoading,
    attemptExpiryError
  } = useExamAttemptExpiry(Number(trackId), language);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsx(RetakeExamButton, {
      language: language,
      trackId: trackId,
      use: "primary"
    }),
    error: mostRecentExamAttemptError || attemptExpiryError || trackError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.expiredAttempt"
    }),
    illustration: "announcement",
    language: language,
    loading: mostRecentExamAttemptLoading || attemptExpiryLoading || trackLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourPreviousScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.expiredAttemptSubheading",
      options: {
        expiryDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: attemptExpiresOn
        })
      }
    }),
    trackId: trackId
  });
};
export default ExamAttemptExpiredScreen;